/* unplugin-vue-components disabled */import { render } from "./go-top.vue?vue&type=template&id=5c1199b8&scoped=true"
import script from "./go-top.vue?vue&type=script&lang=js"
export * from "./go-top.vue?vue&type=script&lang=js"

import "./go-top.vue?vue&type=style&index=0&id=5c1199b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1199b8"]])

export default __exports__